import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PurchaseCancelHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate('/');
    }, 4000);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gradient-to-br from-zinc-950 via-zinc-900 to-zinc-800 text-white px-6">
      <h1 className="text-2xl sm:text-3xl font-extrabold text-accent-creamyRed mb-4">Checkout Canceled</h1>
      <p className="text-zinc-300 text-base sm:text-lg mb-6 max-w-xl">
        No worries — you can upgrade anytime from your profile or the main app page.
      </p>
      <p className="text-sm text-zinc-500 italic">Returning to home...</p>
    </div>
  );
}